// extracted by mini-css-extract-plugin
module.exports = {"title":"Features_title__3Bpqk","subtitle":"Features_subtitle__1hZn9","features":"Features_features__5KfIq"};